



















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ConfirmModal extends Vue {
  @Prop() show!: boolean
  @Prop() message!: string

  handleCancel() {
    this.$emit('click:cancel')
  }

  handleAccept() {
    this.$emit('click:accept')
  }

  handleClose() {
    this.$emit('close')
  }
}
